// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional

 firebase : {

  apiKey: "AIzaSyAGm0TUH_gqVePYosiKKjKHuQTQCeLfNy8",

  authDomain: "saatanaan-cfae6.firebaseapp.com",

  projectId: "saatanaan-cfae6",

  storageBucket: "saatanaan-cfae6.appspot.com",

  messagingSenderId: "288303328307",

  appId: "1:288303328307:web:012621f5bff075c92bc746",

  measurementId: "G-ZLH8BGRXJ9"

 }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
